var BaseStorage = /*#__PURE__*/function () {
  function BaseStorage() {
    var _this = this;

    ['setItem', 'getItem', 'removeItem', 'getAllItems'].forEach(function (method) {
      if (_this[method] === BaseStorage.prototype[method]) {
        throw new Error("BaseStorage method [" + method + "] must be overriden!");
      }
    });
  }

  var _proto = BaseStorage.prototype;

  _proto.extendScope = function extendScope(scope) {
    return scope;
  };

  _proto.setItem = function setItem(key, value, options) {
    throw options;
  };

  _proto.getItem = function getItem(key, options) {
    throw options;
  };

  _proto.removeItem = function removeItem(key, options) {
    throw options;
  };

  _proto.getAllItems = function getAllItems(options) {
    throw options;
  };

  BaseStorage.verify = function verify(strategy) {
    if (strategy instanceof BaseStorage) {
      return strategy;
    } else {
      throw new Error("This class must extend BaseStorage!");
    }
  };

  return BaseStorage;
}();

export { BaseStorage as default };